import React, { useState } from "react";
import api, { formatError } from "@/lib/api";
import { Send, CheckCircle2 } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [err, setErr] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try { await api.post("/contact", form); setSent(true); }
    catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="contact-page" className="max-w-2xl">
      <div className="text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">Contact</div>
      <h1 className="heading-display text-4xl sm:text-5xl mt-1">Stuur een bericht</h1>
      <p className="text-slate-600 mt-3 mb-8">
        Werkt iets niet, klopt een waarde niet, of wil je een afkorting toevoegen? Stuur me een berichtje — ik werk de site dan bij.
      </p>

      {sent ? (
        <div className="gs-card p-6 flex items-start gap-3 bg-emerald-50 border-emerald-200" data-testid="contact-success">
          <CheckCircle2 className="text-emerald-600 mt-1" size={22}/>
          <div>
            <div className="font-bold text-emerald-700">Bedankt! Bericht verzonden.</div>
            <div className="text-sm text-emerald-700 mt-1">Ik probeer binnen een paar dagen te reageren.</div>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="gs-card p-6 space-y-4" data-testid="contact-form">
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Jouw naam</span>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} required className="mt-1 w-full px-3 py-2.5 border border-input rounded-lg bg-white" data-testid="contact-name"/>
          </label>
          <label className="block">
            <span className="text-sm font-medium text-slate-700">E-mail</span>
            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required className="mt-1 w-full px-3 py-2.5 border border-input rounded-lg bg-white" data-testid="contact-email"/>
          </label>
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Bericht</span>
            <textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} required rows={6} className="mt-1 w-full px-3 py-2.5 border border-input rounded-lg bg-white" placeholder="Bv. 'Sprong X klopt niet' of 'Graag afkorting Y toevoegen'" data-testid="contact-message"/>
          </label>
          {err && <div className="text-red-600 text-sm">{err}</div>}
          <button type="submit" disabled={loading} className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2.5 rounded-lg flex items-center gap-2 disabled:opacity-50" data-testid="contact-submit">
            <Send size={16}/> {loading ? "Versturen..." : "Verstuur bericht"}
          </button>
        </form>
      )}
    </div>
  );
}
